import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var XBubbleIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M5,17v3.5a.5.5,0,0,0,.85.35L9,17Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M10.24,3h3.52A8.24,8.24,0,0,1,22,11.24v0A7.76,7.76,0,0,1,14.24,19H9.76A7.76,7.76,0,0,1,2,11.24v0A8.24,8.24,0,0,1,10.24,3Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M15.21,13.17a.86.86,0,0,1,0,1.22.88.88,0,0,1-1.22,0l-2-2-2,2a.88.88,0,0,1-1.22,0,.86.86,0,0,1,0-1.22l2-2-2-2A.86.86,0,0,1,8.79,8,.88.88,0,0,1,10,8l2,2,2-2a.88.88,0,0,1,1.22,0,.86.86,0,0,1,0,1.22l-2,2Z",
    fill: "#fff"
  })]
}), 'XBubbleIcon');